import 'css-chunk:src/app/containers/Home/UsersView/UserDetailView/UserDetails.scss';export default {
  "UserDetails": "_UserDetails_1kcv7_1"
};